import { createFeatureSelector, createSelector } from '@ngrx/store'
import { Features } from '../../../../../state/features.enum'
import { OfflineState } from '../reducers/offline.reducer'

export const offlineActions = createFeatureSelector<OfflineState>(Features.OFFLINE)

export const selectOfflineActions = createSelector(offlineActions, (state) => state?.actions)
